import React, { useState } from "react";
import PropTypes from "prop-types";

//Import module Modal
import Modal from "react-bootstrap/Modal";

import { Form, FormControl, Row, Col } from "react-bootstrap";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const renderTooltipDelete = (props) => (
  <Tooltip {...props}>ลบข้อมูลคู่สัญญารายปี</Tooltip>
);

function ModalListContractYear(props) {
  const [years, setYears] = useState("");
  const [offset, setOffset] = useState(0);
  const [errors, setErrors] = useState(null);
  const [erroroffset, setErroroffset] = useState(null);

  const setField = (value) => {
    setErrors(null);
    setYears(value);
  };
  const setFieldoffset = (value) => {
    setErroroffset(null);
    setOffset(value);
  };
  const clickImport = () => {
    if (years == "") {
      setErrors("ต้องกรอกข้อมูล");
    } else {
      props.import(years.replace("-", "%2D"), offset);
    }
  };
  const handleClose = () => {
    props.setShow(false);
    setErrors(null);
  };
  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>ปีที่ทำการเก็บข้อมูล</Modal.Title>
        </Modal.Header>
        {/* {loadAlert ? <LoadingAlert /> : ""} */}
        <Modal.Body>
          {props.years.map((a, key) => {
            return (
              <li key={key}>
                {a.season + " : " + a.total + " - "}
                <OverlayTrigger placement="top" overlay={renderTooltipDelete}>
                  <a>
                    <i
                      className="bi bi-trash text-danger"
                      onClick={() => props.delete(a.season)}
                    ></i>
                  </a>
                </OverlayTrigger>
              </li>
            );
          })}
        </Modal.Body>
        <Modal.Footer style={{ display: "inline" }}>
          <Row>
            <Col md={4}>
              <FormControl
                placeholder="ปี"
                name="years"
                value={years}
                type="text"
                onChange={(e) => setField(e.target.value)}
                isInvalid={!!errors}
              />
              <Form.Control.Feedback type="invalid">
                {errors}
              </Form.Control.Feedback>
            </Col>
            <Col md={2}>
              <FormControl
                placeholder="offset"
                name="offset"
                value={offset}
                type="number"
                onChange={(e) => setFieldoffset(e.target.value)}
                isInvalid={!!erroroffset}
              />
              <Form.Control.Feedback type="invalid">
                {erroroffset}
              </Form.Control.Feedback>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <button className="btn btn-primary" onClick={clickImport}>
                นำเข้าข้อมูล
              </button>
              <button className="btn btn-warning" onClick={handleClose}>
                ยกเลิก
              </button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalListContractYear;
ModalListContractYear.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  years: PropTypes.array,
  import: PropTypes.func,
  delete: PropTypes.func,
  // setdata: PropTypes.func,
  // onsubmit: PropTypes.func,
};
ModalListContractYear.defaultProps = {
  years: [],
};
